import UNIQUE from '@/common/unique'

export default {
  id: 'quantity',
  name: 'quantity',
  type: 'action',
  moduleName: 'editor_module_quantity',
  dataSet: {
    mods: 'quantity',
    column: [
      {
        columnId: UNIQUE.mid(),
        type: 'quantity',
        hasLang: false,
        value: {
          label: ''
        }
      }
    ]
  },
  setting: {
    layout: {
      options: [
        'fullsize',
        'background',
        'border',
        'text',
        'padding'
      ]
    },
    action: {
      name: 'quantity',
      isRequired: true,
      label: '',
      labelValue: '',
      min: '1',
      max: '3',
      value: '1',
      price: {
        isPrice: true,
        value: '10,000'
      }
    },
    detail: null
  }
}
